<mat-card appearance="raised" class="card-layout">
  <mat-card-header>
    <mat-card-title>
      @if (icon) {
        <mat-icon color="primary">{{ icon }}</mat-icon>
      }
      <span>{{ label | translate }}</span>
    </mat-card-title>
    @if (!(isPhone && omitSubTitleOnMobile)) {
      <mat-card-subtitle
        [innerHTML]="subTitle | translate"
      ></mat-card-subtitle>
    }

    @if (!(isPhone && omitSubTitle2OnMobile)) {
      <mat-card-subtitle
        [innerHTML]="subTitle2 | translate"
      ></mat-card-subtitle>
    }
    <mat-card-subtitle>
      <ng-content select="[subTitleContent]"></ng-content>
    </mat-card-subtitle>
  </mat-card-header>
  <mat-card-content ngClass="card-layout__content">
    <ng-content></ng-content>
    <mat-card-actions>
      <div class="card-layout__buttons">
        <ng-content select=".card-layout-buttons"></ng-content>
      </div>
    </mat-card-actions>
  </mat-card-content>
</mat-card>
